import SharedLayout from '../../components/Layout/Layout';
import styles from './ProductEndOfLife.module.css';
import ProductEndOfLifeContent from './ProductEndOfLifeContent';

interface IProductEndOfLifeProps {
  title: string;
}

export default function ProductEndOfLife({ title }: IProductEndOfLifeProps) {
  return (
    <SharedLayout title={title}>
      <div className={styles.wrapper}>
        <ProductEndOfLifeContent />
      </div>
    </SharedLayout>
  );
}
